import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  DropdownItem,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  BackButton,
  PageHeader,
  KebabDropdown,
} from '../../components';
import { getCurrSample, deleteSample } from '../../redux/samples/actions';
import SampleForm from './SampleForm';
import { getCurrOrg } from '../../redux/orgs/selectors';
import { useConfirmAction, useReadOnly } from '../../utils/hooks';

import layout from '../../styles/layout.module.scss';

export default function EditSample () {
  const dispatch = useDispatch();
  const history = useHistory();
  const readOnly = useReadOnly();
  const confirmAction = useConfirmAction();
  const currOrg = useSelector(getCurrOrg);
  const { id, orgSlug } = useParams();
  const [startedLoading, setStartedLoading] = useState(false);
  const currSample = useSelector((s) => s.samples.currSample);
  const pending = useSelector((s) => s.samples.getCurrSamplePending);
  const error = useSelector((s) => s.samples.getCurrSampleError);

  // Load currSample if not already
  useEffect(() => {
    if (currOrg && _.get(currSample, 'id') != id) {
      dispatch(getCurrSample(id));
      setStartedLoading(true);
    }
  }, [currOrg, currSample]);

  // Failed to load sample. Redirect
  useEffect(() => {
    if (startedLoading && error) {
      history.replace(`/app/${orgSlug}/water-bodies`);
    }
  }, [startedLoading, error, history]);

  const removeSample = useCallback(() => {
    confirmAction({
      action: 'delete',
      subjectType: 'sample',
      subject: currSample.fish_id,
      onConfirm: () => dispatch(deleteSample(Number(id))),
      pendingPath: 'samples.deleteSamplePending',
      errorPath: 'samples.deleteSampleError',
      onSuccess: history.goBack,
    });
  }, [currOrg, currSample, confirmAction]);

  return (
    <div className={layout.page}>
      <PageHeader
        title="Edit Fish Sample"
        coverMenu
      >
        <BackButton />
        { !readOnly && (
          <KebabDropdown right>
            <DropdownItem onClick={removeSample}>
              <FontAwesomeIcon icon="trash" />
              Delete Sample
            </DropdownItem>
          </KebabDropdown>
        )}
      </PageHeader>
      { (!currSample || pending)
        ?
        <div className="text-center">
          <Spinner />
        </div>
        :
        <SampleForm
          onSubmit={history.goBack}
          sample={currSample}
        />
      }
    </div>
  );
}

